import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions/search/search';
import type { CampaignBrain } from './helpers';

interface UseCampanhasOptions {
  uids: string[];
  blockId: string;
}

interface UseCampanhasResult {
  items: CampaignBrain[];
  loading: boolean;
  loaded: boolean;
}

const METADATA_FIELDS = ['UID', 'description', 'image_scales', 'image_field'];

export const getSubrequestKey = (blockId: string) => `campaigns-${blockId}`;

/**
 * Busca por `UID`, e não por caminho: o índice `path` guarda o caminho físico
 * (`/Plone/...`) e o `plone.restapi` só completa esse prefixo quando a
 * requisição passa por um VirtualHostMonster — sem VHM, `path.query` com o
 * caminho do app não casa com nada.
 */
export function useCampaigns({
  uids,
  blockId,
}: UseCampanhasOptions): UseCampanhasResult {
  const dispatch = useDispatch();
  const subrequestKey = getSubrequestKey(blockId);
  const uidsKey = uids.join('|');

  useEffect(() => {
    if (!uidsKey) {
      return;
    }

    const searched = uidsKey.split('|');

    dispatch(
      searchContent(
        '',
        {
          UID: searched,
          b_size: searched.length,
          metadata_fields: METADATA_FIELDS,
        },
        subrequestKey,
      ) as any,
    );
  }, [dispatch, uidsKey, subrequestKey]);

  const subrequest = useSelector(
    (state: any) => state.search?.subrequests?.[subrequestKey],
  );

  const items: CampaignBrain[] | undefined = subrequest?.items;

  return {
    items: useMemo(() => items ?? [], [items]),
    loading: subrequest?.loading ?? false,
    loaded: subrequest?.loaded ?? false,
  };
}

export default useCampaigns;
